// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1YDZa","title":"styles_title__1aOwX"};